














































































































































import { Component } from 'vue-property-decorator';

import { BaseGridComponent, GridPagerCpt, GridTableCpt } from '@/core/components';
import { DashboardCollectionModel, DashboardFilterModel, FileDownloadModel } from '@/core/models';
import { CompanyService, WorkshopService, Utils, QuestionnaireService, DownloadService } from '@/core/services';
import { DashboardGridFiltersCpt, WorkshopStatusCpt, RevStatusCpt, FollowUpStatusCpt } from './';

@Component({
  components: {
    GridPagerCpt,
    DashboardGridFiltersCpt,
    WorkshopStatusCpt,
    RevStatusCpt,
    FollowUpStatusCpt,
    GridTableCpt,
  },
})
export default class DashboardGridCpt extends BaseGridComponent<DashboardCollectionModel, DashboardFilterModel> {
  filter = {
    sectorId: 0,
    companyName: '',
  } as DashboardFilterModel;

  downloadingReport = false;
  columns = [
    { label: 'Client name', prop: 'name', slot: 'name', width: '120px', sortable: true },
    { label: 'Date', prop: 'workshop.eventDate', slot: 'eventDate', width: '100px', sortable: true },
    {
      label: 'Workshop County',
      prop: 'workshop.countyLookup.text',
      slot: 'workshopCountyName',
      width: '155px',
      sortable: true,
    },
    { label: 'Workshop Region', prop: 'regionLookup.text', slot: 'regionName', width: '155px', sortable: true },
    { label: 'Client County', prop: 'countyLookup.text', slot: 'countyName', width: '130px', sortable: true },
    { label: 'Sector', prop: 'companySectorLookup.text', slot: 'companySectorName', width: '95px', sortable: true },
    { label: 'Facilitator', prop: 'userDetail.firstName', slot: 'facilitatorName', width: '110px', sortable: true },
    {
      label: 'Skills consultant',
      prop: 'userDetail.firstName',
      slot: 'skillsConsultant',
      width: '145px',
      sortable: false,
    },
    {
      label: 'Workshop St.',
      prop: 'workshopStatusLookup.text',
      slot: 'workshopStatusName',
      width: '130px',
      sortable: true,
    },
    { label: 'Revision St.', prop: 'revStatusLookup.text', slot: 'revStatusName', width: '120px', sortable: true },
    {
      label: 'Follow-Up St.',
      prop: 'followUpStatusLookup.text',
      slot: 'followupStatusName',
      width: '130px',
      sortable: true,
    },
    { label: 'Updated on', prop: 'dateUpdated', slot: 'lastUpdated', width: '120px', sortable: true },
    { label: 'Notes', prop: 'comments', width: '115px', stot: 'comments', sortable: true },
    { label: 'Actions', prop: 'actions', slot: 'actions', width: '377px', align: 'center' },
  ];

  async created() {
    this.initializeFilters();
    this.load();
  }

  private async downloadFollowUpReport(companyId: number) {
    this.downloadingReport = true;
    try {
      await CompanyService.downloadFollowUpReport(companyId);
    } finally {
      this.downloadingReport = false;
    }
  }

  private async downloadSkillsPlan(companyId: number) {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await QuestionnaireService.downloadCriticalSkillsReportForCompany(companyId);
      await QuestionnaireService.generateCriticalSkillsFile(response);
    } finally {
      this.downloadingReport = false;
    }
  }
  private filterUpdated(filter: DashboardFilterModel) {
    this.filter = filter;
    this.filter.page = 1;
    this.load();
  }

  private async downloadSosReport(filter: DashboardFilterModel) {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await WorkshopService.downloadSosReport(filter);

      const blob = new Blob([Utils.getArrayBuffer(atob(response.data))], { type: response.contentType });
      DownloadService.download(blob, response.fileName);
    } finally {
      this.downloadingReport = false;
    }
  }

  private async downloadSkillsConsultantReport() {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await WorkshopService.downloadSkillsConsultantReport(this.filter);

      const blob = new Blob([Utils.getArrayBuffer(atob(response.data))], { type: response.contentType });
      DownloadService.download(blob, response.fileName);
    } finally {
      this.downloadingReport = false;
    }
  }

  private load() {
    this.initialize((filter: DashboardFilterModel) => CompanyService.dashboardFilter(filter), 'dashboard', this.filter);
  }

  private initializeFilters() {
    if (this.filter) {
      const query = this.$route.query as any;
      this.filter.regionId = !!query.regionId ? parseInt(query.regionId, 10) : 0;
      this.filter.countyId = !!query.countyId ? parseInt(query.countyId, 10) : 0;
      this.filter.sectorId = !!query.sectorId ? parseInt(query.sectorId, 10) : 0;
      this.filter.workshopStatusId = !!query.workshopStatusId ? parseInt(query.workshopStatusId, 10) : 0;
      this.filter.search = query.search || '';
      this.filter.companyName = query.companyName || '';
      this.filter.startDate = query.startDate ? new Date(query.startDate) : (null as any);
      this.filter.endDate = query.endDate ? new Date(query.endDate) : (null as any);
      this.filter.sortBy = query.sortBy || 'workshop.eventDate';
      this.filter.sortOrder = query.sortOrder || 'desc';

      const start = new Date();
      start.setDate(start.getDate() - 7);
      if (!this.filter.startDate) {
        this.filter.startDate = start;
      }

      if (!this.filter.endDate) {
        const end = new Date();
        end.setDate(start.getDate() + 14);
        this.filter.endDate = end;
      }
    }
  }
}
